import { Events, MenuController, NavController } from "@ionic/angular";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, from } from "rxjs";
import { map, timeout } from "rxjs/operators";
import { AjaxService } from "./ajax.service";
import { TokenService } from "./token.service";
import { GlobalService } from "./global.service";
import { Storage } from "@ionic/storage";
import { AppConfig } from "./app.config";
import { IonicService } from "./ionic.service";

declare var globalConfig: any;

@Injectable()
export class AuthService {
  constructor(
    private http: HttpClient,
    private tokenService: TokenService,
    private ajaxService: AjaxService,
    private events: Events,
    private storage: Storage,
    private menu: MenuController,
    private navCtrl: NavController,
    private ionicService: IonicService,
  ) {}

  async isLoggedin() {
    GlobalService.user = GlobalService.user || (await this.storage.get("user"));
    if (!GlobalService.user) return false;
    if (!GlobalService.user.access_token || !GlobalService.user.session_proof) {
      GlobalService.user = null;
      return false;
    }

    var loggedIn = !this.tokenService.isTokenExpired(
      GlobalService.user.access_token,
    );
    if (!loggedIn) GlobalService.user = null;

    return loggedIn;
  }

  public changeSurvey() {
    this.storage.set("user", GlobalService.user);
  }

  getUser(): Observable<any> {
    return from(this.storage.get("user"));
  }

  login(
    officeCode: string,
    userName: string,
    password: string,
  ): Observable<boolean> {
    const body = new HttpParams()
      .set("grant_type", "password")
      .set("userName", userName)
      .set("password", password)
      .set("officeCode", officeCode)
      .set("client_id", AppConfig.clientId);

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return this.http
      .post(AppConfig.baseUrl + "token", body.toString(), { headers })
      .pipe(
        timeout(12000),
        map((response: any) => {
          var user = this.tokenService.setUser(response);
          GlobalService.user = user;
          return user;
        }),
      );
  }

  changePassword(
    currentPassword: string,
    newPassword: string,
  ): Observable<boolean> {
    var data: any = {
      CurrentPassword: currentPassword,
      NewPassword: newPassword,
    };

    return this.ajaxService
      .callService("user/changePassword", false, "PUT", data)
      .pipe(
        map((response: Response) => {
          return true;
        }),
      );
  }

  async logout() {
    await this.ionicService.clearLoaders();
    const hadSession = !!(GlobalService.user && GlobalService.user.access_token);
    // Revoke session server-side (VAPT: proper session termination)
    if (hadSession) {
      try {
        await this.ajaxService
          .callPostService("user/logout", {}, false)
          .toPromise();
      } catch {
        // Session may already be revoked (e.g. tamper 403); still clear client state.
      }
    }

    this.menu.close();
    this.menu.enable(false);

    GlobalService.user = null;
    await this.storage.remove("user");
    this.navCtrl.navigateRoot("/login");
  }

  static hasRole(roleId, user = null): boolean {
    user = user || GlobalService.user;
    if (!user || !user.Role) return false;
    else {
      return user.Role.toLowerCase() == roleId.toLowerCase();
    }
  }

  static hasPermission(permission, user = null): boolean {
    user = user || GlobalService.user;
    if (!user || !user.Role || !user.Role.Permissions) return false;

    let hasPermission = user.Role.Permissions.find((p) => p.Id == permission)
      ? true
      : false;
    return hasPermission;
  }
}
